import API from '@/views/Fdc/Apis'
import _ from 'lodash'
import BriqueChart from '@/components/BriqueChart/BriqueChart.js'

/**
 * Detectoin > Multivariate Detection - Hoteling T2
 * Hoteling T2 Tab
 */
export default {
  name: 'HotelingT2',
  components: {
  },
  beforeMount () {
    // this.initColumns()
  },
  mounted () {
    this.briqueChart = BriqueChart
  },
  computed: {
  },
  watch: {
    /**
     * summaryData 변화 감지
     */
    summaryData () {
      this.chartData = []
      this.uclPercent = 90
      this.uslPercent = 95

      if (this.summaryData.hotelingT2) {
        this.setDatas()
      }
    }
  },
  props: {
    summaryData: {
      type: Object,
      default () {
        return null
      }
    },
    selectedModelData: {
      type: Object,
      default () {
        return null
      }
    }
  },
  methods: {
    /**
     * 감섹 Validation
     * @returns {Boolean} validation 성공 여부
     */
    _searchValidation () {
      if (!(this.selectedModelData != null && Object.keys(this.selectedModelData).length > 0)) {
        this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_SELECTED', ['Model']))
        return true
      }
      if (this.summaryData.summaryDataList == null) {
        this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_EXIST', ['Summary Data']))
        return true
      }
      if (!(this.summaryData.selectedVariables != null && Object.keys(this.summaryData.selectedVariables).length > 0)) {
        this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_SELECTED', ['Features']))
        return true
      }
      if (this.summaryData.trainingModel == null) {
        this.$dialog.alert(this.$t('fdc.FAULT_DETECTION.MESSAGE.INFORM_NOT_RUN_PCA'))
        return true
      }
      return false
    },
    /**
     * Hoteling T2 조회
     */
    async searchHotelingT2 () {
      if (this._searchValidation()) {
        return
      }
      this.summaryData.uclPercent = this.uclPercent * 0.01
      this.summaryData.uslPercent = this.uslPercent * 0.01
      const payload = {
        dataList: this.summaryData,
        modelType: 'mva'
      }

      this.$emit('save-disabled', false)
      await API.Analysis.runHotelingT2(payload, this.callback)
    },
    /**
     * Hoteling T2 조회 callback
     * @param {Object} searchData Hoteling T2 조회 결과
     */
    callback (searchData) {
      this.summaryData.ucl = searchData.ucl
      this.summaryData.usl = searchData.usl
      this.summaryData.hotelingT2 = searchData.hotelingT2
      this.setDatas()
    },
    /**
     * Chart data 설정
     */
    setDatas () {
      const hotelingT2 = _.clone(this.summaryData.hotelingT2)
      // if (this.summaryData.summaryDataList) {
      //   for (let i in this.summaryData.summaryDataList.datas) {
      //     let data = this.summaryData.summaryDataList.datas[i]
      //     hotelingT2.hotelingT2List[i].endDt = data.endDt
      //     hotelingT2.hotelingT2List[i].lotId = data.lotId
      //     hotelingT2.hotelingT2List[i].substId = data.substId
      //   }
      // }
      // this.chartData = hotelingT2.hotelingT2List
      this.chartData = hotelingT2.hotelingT2Chart
      this.drawChartArea(hotelingT2.hotelingT2Chart)
      // this.drawChartAnnotation()
      // this.drawTraces(this.chartData)
    },
    /**
     * Run Button 클릭
     */
    clickRun () {
      this.searchHotelingT2()
    },
    /**
     * Hoteling T2 Chart draw
     * @param {*} traces chart data 배열
     */
    drawChartArea (traces) {
      traces.map(trace => {
        trace.mode = 'markers'
        trace.type = 'scattergl'
        trace.hovertemplate = this.summaryData.summaryDataList ? '<b>Datetime:</b> %{text.endDt|%Y-%m-%d %H:%M:%S.%L}<br><b>LOT ID:</b> %{text.lotId}<br><b>Substrate ID:</b> %{text.substId}<br><b>T2:</b> %{y:.4f}<extra></extra>' : '<b>T2:</b> %{y:.4f}<extra></extra>'
        if (trace.name === 'UCL') {
          trace.showlegend = false
          trace.marker = {
            color: 'orange'
          }
        } else if (trace.name === 'USL') {
          trace.showlegend = false
          trace.marker = {
            color: 'red'
          }
        }
      })
      // let traces = [
      //   {
      //     name: 'index',
      //     mode: 'markers',
      //     type: 'scattergl',
      //     x: [],
      //     y: [],
      //     text: [],
      //     hovertemplate: this.summaryData.summaryDataList ? '<b>Datetime:</b> %{text.endDt}<br><b>LOT ID:</b> %{text.lotId}<br><b>Substrate ID:</b> %{text.substId}<br><b>T2:</b> %{y:.4f}<extra></extra>' : '<b>T2:</b> %{y}<extra></extra>'
      //   },
      //   {
      //     name: 'UCL',
      //     mode: 'markers',
      //     type: 'scattergl',
      //     x: [],
      //     y: [],
      //     text: [],
      //     showlegend: false,
      //     marker: {
      //       color: 'orange'
      //     },
      //     hovertemplate: this.summaryData.summaryDataList ? '<b>Datetime:</b> %{text.endDt}<br><b>LOT ID:</b> %{text.lotId}<br><b>Substrate ID:</b> %{text.substId}<br><b>T2:</b> %{y:.4f}<extra></extra>' : '<b>T2:</b> %{y}<extra></extra>'
      //   },
      //   {
      //     name: 'USL',
      //     mode: 'markers',
      //     type: 'scattergl',
      //     x: [],
      //     y: [],
      //     text: [],
      //     showlegend: false,
      //     marker: {
      //       color: 'red'
      //     },
      //     hovertemplate: this.summaryData.summaryDataList ? '<b>Datetime:</b> %{text.endDt}<br><b>LOT ID:</b> %{text.lotId}<br><b>Substrate ID:</b> %{text.substId}<br><b>T2:</b> %{y:.4f}<extra></extra>' : '<b>T2:</b> %{y}<extra></extra>'
      //   }
      // ]
      let layout = {
        legend: {
          orientation: 'h',
          y: 1.2
        },
        margin: {
          r: 150
        },
        hovermode: 'closest',
        shapes: [],
        annotations: []
      }
      let config = {
        responsive: true,
        scrollZoom: true,
        displaylogo: false,
        displayModeBar: true
      }
      let promise = BriqueChart.newPlot('mvaDetectionHotelingT2', traces, layout, config)

      promise.then(() => {
        // this.drawTraces(this.chartData)
        this.drawChartAnnotation()
      })

      // let yMin = 0; let yMax = 100; let margin = 0; const ratio = 0.2; var yValues = this.chartData.map(function (o) { return o.t2 })
      // yValues.push(this.uslVal); yValues.push(this.uclVal)
      // yMax = Math.max(...yValues)
      // yMin = Math.min(...yValues)
      // margin = (yMax - yMin) * ratio
      // this.yMin = yMin - margin
      // this.yMax = yMax + margin
    },
    /**
     * Chart Alarm Line Annotation Draw
     */
    drawChartAnnotation () {
      this.uslVal = this.summaryData.usl
      this.uclVal = this.summaryData.ucl

      let element = document.querySelector('#mvaDetectionHotelingT2')
      if (_.isEmpty(element)) return
      let layout = element.layout
      if (_.isEmpty(layout)) return
      layout.shapes = [
        {
          type: 'line',
          xref: 'paper',
          x0: 0,
          x1: 1,
          yref: 'y',
          y0: this.uslVal,
          y1: this.uslVal,
          line: { color: 'red', width: 2 }
        }, {
          type: 'line',
          xref: 'paper',
          x0: 0,
          x1: 1,
          yref: 'y',
          y0: this.uclVal,
          y1: this.uclVal,
          line: { color: 'orange', width: 2 }
        }
      ]
      layout.annotations = [
        {
          xref: 'paper',
          x: 1,
          xanchor: 'left',
          yref: 'y',
          y: this.uslVal,
          text: 'USL: ' + this.uslVal.toFixed(4),
          showarrow: false
        }, {
          xref: 'paper',
          x: 1,
          xanchor: 'left',
          yref: 'y',
          y: this.uclVal,
          text: 'UCL: ' + this.uclVal.toFixed(4),
          showarrow: false
        }
      ]
      BriqueChart.relayout('mvaDetectionHotelingT2', layout)
    }
    // drawTraces (trace) {
    //   let x = trace.filter(e => e.t2 < e.ucl).map(e => e.index)
    //   let y = trace.filter(e => e.t2 < e.ucl).map(e => e.t2)
    //   let text = trace.filter(e => e.t2 < e.ucl).map(e => {
    //     return {
    //       endDt: e.endDt,
    //       lotId: e.lotId,
    //       substId: e.substId
    //     }
    //   })
    //   let uclX = trace.filter(e => e.t2 >= e.ucl && e.t2 < e.usl).map(e => e.index)
    //   let uclY = trace.filter(e => e.t2 >= e.ucl && e.t2 < e.usl).map(e => e.t2)
    //   let uclText = trace.filter(e => e.t2 >= e.ucl && e.t2 < e.usl).map(e => {
    //     return {
    //       endDt: e.endDt,
    //       lotId: e.lotId,
    //       substId: e.substId
    //     }
    //   })
    //   let uslX = trace.filter(e => e.t2 >= e.usl).map(e => e.index)
    //   let uslY = trace.filter(e => e.t2 >= e.usl).map(e => e.t2)
    //   let uslText = trace.filter(e => e.t2 >= e.usl).map(e => {
    //     return {
    //       endDt: e.endDt,
    //       lotId: e.lotId,
    //       substId: e.substId
    //     }
    //   })
    //   BriqueChart.extendTraces('mvaDetectionHotelingT2', { x: [x, uclX, uslX], y: [y, uclY, uslY], text: [text, uclText, uslText] }, [0, 1, 2])
    // }
    /**
     * null 값 check
     * @param {*} value check value
     */
    // isEmpty (value) {
    //   if (value === '' || value == null || value === undefined || (value != null && typeof value === 'object' && !Object.keys(value).length)) {
    //     return true
    //   } else {
    //     return false
    //   }
    // }
  },
  data () {
    return {
      uclVal: null, // UCL value
      uslVal: null, // USL value
      chartData: [], // Hoteling T2 chart data
      uclPercent: 90, // UCL percent
      uslPercent: 95, // USL percent
      briqueChart: null // BriqueChart Component 객체
    }
  }
}
